import React from 'react';
import { RichText as JssRichText, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  RteWrapper,
  LayoutContainer,
  PageSection,
  PageSectionContent,
} from '@greystar/designsystem';
import { ComponentWithContextProps } from '@greystar/ui';

const GuideFaqs = (props: ComponentWithContextProps): JSX.Element => {
  const { sitecoreContext } = props;
  const faqs = sitecoreContext?.route?.fields?.['Additional Text 1'] as RichTextField;

  if (!faqs) {
    return <></>;
  }

  return (
    <PageSection isTopFlushed isBottomFlushed>
      <PageSectionContent>
        <LayoutContainer paddingTop="3xl" paddingBottom="3xl">
          <div className={`component rich-text`}>
            <div className="component-content">
              <RteWrapper>
                <JssRichText field={faqs} />
              </RteWrapper>
            </div>
          </div>
        </LayoutContainer>
      </PageSectionContent>
    </PageSection>
  );
};

export default GuideFaqs;
